import { ref, computed } from "vue";
import type { Testimony } from "~/types/general";

export const useTestimony = () => {
  const testimony = ref<Testimony[]>([]);
  const isLoading = ref(false);
  const error = ref<any>(null);

  const fetchTestimony = async (testimonies: Testimony[]) => {
    isLoading.value = true;
    error.value = null;

    try {
      testimony.value = testimonies;
    } catch (err) {
      error.value = err;
    } finally {
      isLoading.value = false;
    }
  };

  const averageRating = computed(() => {
    if (!testimony.value.length) return 0;

    const total = testimony.value.reduce((sum, item) => sum + item.rate, 0);
    return Math.round(total / testimony.value.length);
  });

  function formatNumber(value: number): string {
    if (value >= 1_000_000) {
      return (value / 1_000_000).toFixed(1).replace(/\.0$/, '') + 'M';
    }
    if (value >= 1_000) {
      return (value / 1_000).toFixed(1).replace(/\.0$/, '') + 'K';
    }
    return value.toString();
  }

  const reviewCount = computed(() => formatNumber(testimony.value.length));

  return {
    testimony,
    isLoading,
    reviewCount,
    averageRating,
    error,
    fetchTestimony,
  };
};
